import React, { Component } from 'react'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import { Detail as UserInfo, RolesBox } from '@/components/usersManagement'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/usersManagement'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import LoadingIndicator from '@/components/LoadingIndicator'
import { localized } from '@/decorators/localized'
import { Button } from '@/components/button'
import context from '@/context'
import { WhiteBox } from '@/components/Layout/Layout.Box'
import { Row, Col } from 'reactstrap'
import { BsrsGrid, commandColumnProps, NameColumn, DateCell, DateFilterCell, BooleanColumn } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { dialogTypes } from '@/dialogs'
import { jobsGridButtons } from './gridButtons'
import InChangeOfInstitutionsView from './inChargeOfInstitutionsView'
import IndividualDetail from '@/components/userProfile/individualDetail'
import { DataLoader } from '@/components/dataLoader'
import { ResetPasswordButton } from '@/components/usersManagement/resetPasswordButton'
import { withPermissions } from '@/decorators/withPermissions'
import Impersonators from './impersonators'

const NEW_JOB = {
  id: 0,
  organizationalUnit: null,
  jobPosition: null,
  validFrom: null,
  validTo: null,
  acting: false
}

const mapStateToProps = (state) => {
  return {
    userFetching: state.usersManagement.userFetching,
    userFetched: state.usersManagement.userFetched,
    user: state.usersManagement.user,
    institutionChanging: state.usersManagement.institutionChanging,
    userJobsComponentKey: state.usersManagement.userJobsComponentKey,
    userJobSaving: state.usersManagement.userJobSaving,
    userRolesFetching: state.usersManagement.userRolesFetching,
    userRolesItems: state.usersManagement.userRolesItems,
    resetTwoFactorFetching: state.usersManagement.resetTwoFactorFetching,
    userDelete: state.usersManagement.userDelete
  }
}

const mapDispatchToProps = {
  getUser: actionCreators.getUser,
  setUserState: actionCreators.setUserState,
  generatePasswordResetToken: actionCreators.generatePasswordResetToken,
  approveUser: actionCreators.approveUser,
  addToInstitution: actionCreators.addToInstitution,
  removeFromInstitution: actionCreators.removeFromInstitution,
  openDialog: dialogActions.openDialog,
  saveUserJob: actionCreators.saveUserJob,
  deleteUserJob: actionCreators.deleteUserJob,
  resetTwoFactorAuthForUser: actionCreators.resetTwoFactorAuthForUser,
  deleteUser: actionCreators.deleteUser
}

@localized()
@withPermissions()
@connect(mapStateToProps, mapDispatchToProps)
class Detail extends Component {
  setUserState = () => {
    const { user } = this.props
    this.props.setUserState({
      id: user.id,
      stateCode: 'BlockOrActivate'
    }, true)
  }

  generatePasswordResetToken = () => {
    const { user } = this.props

    this.props.generatePasswordResetToken(user.emailAddress)
  }

  approve = () => {
    const { user } = this.props

    this.props.approveUser(user.id, true)
  }

  getButtons (user) {
    let sourceActionButtons = []

    if (user.approvedAt === null) {
      sourceActionButtons.push(
        <Button
          key='approveButton'
          color='primary'
          className='btn btn-sm'
          onClick={this.approve}
          confirmTitle='UsersManagement.ApproveConfirmTitle'
          confirmText='UsersManagement.ApproveConfirmText'
          icon='check'>
          <Resx name='UsersManagement.ApproveUser' />
        </Button>)
    }
    sourceActionButtons.push(
      <Button
        key='blockActivateButton'
        color='primary'
        className='btn btn-sm'
        onClick={this.setUserState}
        confirmTitle={user.isActive ? 'UsersManagement.SetInactiveConfirmTitle' : 'UsersManagement.SetActiveConfirmTitle'}
        confirmText={user.isActive ? 'UsersManagement.SetInactiveConfirmText' : 'UsersManagement.SetActiveConfirmText'}
        icon={user.isActive ? 'lock-open' : 'lock'}>
        <Resx name='UsersManagement.Activate' />
      </Button>)
    sourceActionButtons.push(
      <ResetPasswordButton key='resetPasswordButton' onClick={this.generatePasswordResetToken} user={user} openDialog={this.props.openDialog} />
    )
    sourceActionButtons.push(
      <Button
        key='resetTwoFactor'
        color='primary'
        className='btn btn-sm'
        icon={this.props.resetTwoFactorFetching ? 'loader bx-spin' : ''}
        disabled={!user.isTwoFactorEnabled || this.props.resetTwoFactorFetching}
        confirmTitle='UsersManagement.ConfirmResetTwoFactorTitle'
        confirmText='UsersManagement.ConfirmResetTwoFactorText'
        onClick={this.resetTwoFactor}>
        <Resx name='UsersManagement.ResetTwoFactor' />
      </Button>
    )
    if (!user.isEmailConfirmed) {
      sourceActionButtons.push(
        <Button
          key='deleteUser'
          color='danger'
          className='btn btn-sm'
          icon={this.props.userDelete ? 'loader bx-spin' : 'trash'}
          confirmTitle='UsersManagement.DeleteConfirmTitle'
          confirmText='UsersManagement.DeleteConfirmText'
          onClick={() => this.props.deleteUser(user.id)}>
          <Resx name='Common.Delete' />
        </Button>
      )
    }

    return sourceActionButtons
  }

  componentWillMount () {
    const { id } = this.props.match.params

    if (id) {
      this.props.getUser(id)
    }
  }

  addInstitution = () => {
    const { user } = this.props
    this.props.openDialog({
      dialogType: dialogTypes.institution,
      primaryButtonText: 'Common.SaveAndClose',
      onAction: (institution) => {
        this.props.addToInstitution(user.id, institution)
      }
    })
  }

  removeInstitution = (dataItem) => {
    const { user } = this.props

    this.props.removeFromInstitution(user.id, dataItem.id)
  }

  resetTwoFactor = () => {
    const { user, resetTwoFactorAuthForUser } = this.props
    resetTwoFactorAuthForUser(user.id)
  }
  editJob (job) {
    this.props.openDialog({
      dialogType: dialogTypes.job,
      primaryButtonText: 'Common.SaveAndClose',
      onAction: (job) => {
        const input = {
          id: job.id,
          userId: this.props.user.id,
          organizationalUnitId: job.organizationalUnitId,
          jobPositionId: job.jobPosition.id,
          validFrom: job.validFrom,
          validTo: job.validTo,
          acting: job.acting
        }
        this.props.saveUserJob(input)
      },
      localize: this.props.localize,
      locale: this.props.locale,
      job,
      userId: this.props.user.id
    })
  }

  renderInChargeOfInstitutions () {
    const { user } = this.props

    if (user.isInternalUser === true) {
      return (
        <Col xl='6'>
          <InChangeOfInstitutionsView user={user} />
        </Col>
      )
    }
    return null
  }

  renderImpersonators () {
    const { user } = this.props

    if (user.isInternalUser === true) {
      return (
        <Col xl='6'>
          <Impersonators user={user} />
        </Col>
      )
    }
    return null
  }

  renderJobs () {
    const { user, localize, locale, openDialog, userJobSaving, isGranted } = this.props
    if (isGranted('CanViewOrganizationalUnitManagement')) {
      if (user.isInternalUser === true) {
        const canManage = isGranted('CanManageOrganizationalUnits')
        return (
          <Col xl='6'>
            {userJobSaving
              ? <LoadingIndicator />
              : <WhiteBox header='JobPosition.Jobs'>
                {canManage && <Button color='primary' className='btn-sm' onClick={() => this.editJob({ ...NEW_JOB })} icon='plus'>
                  <Resx name='Common.Add' />
                </Button>}
                <BsrsGrid
                  simpleView
                  dataSource={request => context.api.jobsService.getUserJobsTableData(this.props.match.params.id, request)}
                  lastReloadedAt={this.props.userJobsComponentKey}>
                  {NameColumn({
                    locale,
                    nameProp: 'organizationalUnitName',
                    latinNameProp: 'organizationalUnitLatinName',
                    title: localize('OrganizationalUnit.Title'),
                    editable: false
                  })}
                  {NameColumn({ locale, nameProp: 'jobPositionName', latinNameProp: 'jobPositionLatinName', title: localize('JobPosition.JobPositionTitle'), editable: false })}
                  <Column field='validFrom' title={localize('Common.ValidFrom')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
                  <Column field='validTo' title={localize('Common.ValidTo')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
                  {BooleanColumn({ field: 'acting', title: localize('Common.Acting'), width: '100px' })}
                  <Column cell={jobsGridButtons({ canManage, openDialog, deleteUserJob: id => this.props.deleteUserJob(id), editJob: job => this.editJob(job), localize, locale })} width='50px'
                    editable={false} />
                </BsrsGrid>
              </WhiteBox>}
          </Col>
        )
      }
    }

    return null
  }

  renderRoles () {
    const { user } = this.props

    if (user.id) {
      return (
        <React.Fragment>

          {user.isInternalUser === true
            ? <Col xl='6'>
              <RolesBox userId={user.id} internal simpleView />
            </Col>
            : ''
          }

          <Col xl='6'>
            <RolesBox userId={user.id} simpleView />
          </Col>
        </React.Fragment>
      )
    }
  }

  render () {
    const { user, userFetched, localize, institutionChanging, isGranted } = this.props
    return (
      <Main path={[user.userName && { text: user.userName, localized: true }]}>
        <MainTop>
          <MainTopTitle backUrl='/users'>
            <Resx name='UsersManagement.Detail' />
          </MainTopTitle>
          <MainTopLeft>
            {this.getButtons(user)}
          </MainTopLeft>
        </MainTop>
        <MainBody clear>
          {!userFetched
            ? <LoadingIndicator />
            : <React.Fragment>
              <UserInfo user={user} canEditLegacyCode />
              {user.individualId && isGranted('CanViewIndividuals') &&
              <DataLoader dataSource={() => context.api.individualService.getForUserDetail(user.individualId)} render={({ data, loading }) => (
                loading
                  ? <WhiteBox>
                    <LoadingIndicator />
                  </WhiteBox>
                  : !data ? null : <IndividualDetail individual={data} headerText={localize('UserProfile.Individual')} />
              )} />
              }
              <Row>
                <Col xl='6'>
                  <WhiteBox header='UsersManagement.ReportAppAccess'>
                    <Button color='primary' className='btn-sm' onClick={this.addInstitution} icon='plus'>
                      <Resx name='Common.Add' />
                    </Button>

                    <React.Fragment>
                      {institutionChanging
                        ? <LoadingIndicator />
                        : <BsrsGrid items={user.allowedInstitutions} simpleView>
                          <Column field='name' title={localize('Common.Name')} />
                          <Column field='latinName' title={localize('Common.LatinName')} />
                          <Column title={localize('UsersManagement.Action')} {...commandColumnProps({ deleteAction: this.removeInstitution })} />
                        </BsrsGrid>
                      }
                    </React.Fragment>
                  </WhiteBox>
                </Col>
                {this.renderJobs()}
              </Row>
              <Row>
                {this.renderRoles()}
              </Row>
              <Row>
                {this.renderInChargeOfInstitutions()}
                {this.renderImpersonators()}
              </Row>
            </React.Fragment>
          }
        </MainBody>
      </Main>
    )
  }
}

export default Detail



// WEBPACK FOOTER //
// ./src/internal-app/pages/usersManagement/detail.js